export default "__VITE_ASSET__4AmBJ0Mn__"